import { C as CosmosIconPlay$1, d as defineCustomElement$1 } from './p-mocQpgx7.js';

const CosmosIconPlay = CosmosIconPlay$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPlay, defineCustomElement };
